// extracted by mini-css-extract-plugin
module.exports = {"USATodayContainer":"kQXu-TI7YD4ldKvxgflo9Q=="};